import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import authServices from "../api/services/authService";
import { handleApiError } from "../utils/apiHelpers";
import Cookies from "js-cookie";

export const loginService = createAsyncThunk(
  "auth/login",
  async (credentials, thunkAPI) => {
    try {
      const response = await authServices.login(credentials);
      if (response && response.data) {
        Cookies.set("accessToken", response.data?.token, {
          expires: 1,
          secure: true,
          sameSite: "Strict",
        });
        return response.data;
      }
      throw new Error("No data found");
    } catch (error) {
      handleApiError(error);
      return thunkAPI.rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const otpService = createAsyncThunk(
  "auth/sendOtp",
  async (credentials, thunkAPI) => {
    try {
      const response = await authServices.sendOtp(credentials);
      if (response && response.data) {
        return response.data;
      }
      throw new Error("No data found");
    } catch (error) {
      handleApiError(error);
      return thunkAPI.rejectWithValue(error.response?.data || error.message);
    }
  }
);

const authSlice = createSlice({
  name: "auth",
  initialState: {
    user: Cookies.get("accessToken") ? true : null,
    password: "",
    loading: false,
    error: null,
  },
  reducers: {
    setPassword: (state, action) => {
      state.password = action.payload;
    },

    logout: (state) => {
      state.user = null;
      state.loading = false;
      state.error = null;
      Cookies.remove("accessToken");
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(loginService.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(loginService.fulfilled, (state, action) => {
        state.error = null;
        state.loading = false;
        state.user = action.payload;
      })
      .addCase(loginService.rejected, (state, action) => {
        state.error = null;
        state.loading = false;
        state.error = action.payload;
      });

    builder
      .addCase(otpService.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(otpService.fulfilled, (state, action) => {
        state.error = null;
        state.loading = false;
        state.user = action.payload;
      })
      .addCase(otpService.rejected, (state, action) => {
        state.error = null;
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { setPassword, logout } = authSlice.actions;

export default authSlice.reducer;
